import { create } from 'zustand'
import { UploadTask } from '@renderer/types/upload'

export interface UploadProgress {
  uploading: number
  uploaded: number
  total: number
  failed: number
  pending: number
}

interface UploadStoreState {
  progress: UploadProgress
  _setProgress: (progress: UploadProgress) => void
  _resetProgress: () => void
}

const initialState = {
  uploading: 0,
  uploaded: 0,
  total: 0,
  failed: 0,
  pending: 0
}

export const useUploadStore = create<UploadStoreState>((set) => ({
  progress: initialState,
  _setProgress: (progress): void => set({ progress }),
  _resetProgress: (): void => set({ progress: initialState })
}))

export function updateUploadProgress(tasks: UploadTask[]): void {
  const total = tasks.length
  if (total === 0) {
    useUploadStore.getState()._resetProgress()
    return
  }

  const uploaded = tasks.filter((t) => t.status === 'completed').length
  const uploading = tasks.filter((t) => t.status === 'uploading').length
  const failed = tasks.filter((t) => t.status === 'failed').length
  const pending = tasks.filter((t) => t.status === 'pending').length

  useUploadStore.getState()._setProgress({
    total,
    uploaded,
    uploading,
    failed,
    pending
  })
}
